import React from 'react';

import { designSystem } from '@/styles/theme';

interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

const NavRegionIcon: React.FC<IconProps> = ({ width = 24, height = 24, color = designSystem.colors.primary }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2Z" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="12" cy="9" r="2.5" fill={color}/>
  </svg>
);

export default NavRegionIcon;
